import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "owl.carousel/dist/assets/owl.carousel.min.css";
import "owl.carousel/dist/assets/owl.theme.default.min.css";
import appRoutes from "./routes";
import ProtectedRoute from "./Component/ProtectedRoute";
import SessionTimeoutWatcher from "./Component/CommonFunctionality/SessionTimeoutWatcher";
import PushNotificationListener from "./Component/CommonFunctionality/PushNotificationListener";

const ErrorPage = lazy(() => import("./Component/ForgotPassword/ErrorPage"));

// App.js is route-config-agnostic — it never imports an individual page
// component (only ErrorPage, for the catch-all). All routing lives in
// ./routes, split into `protected` (needs useAuthGuard, rendered inside
// the single <ProtectedRoute> layout route below) and public. Adding a
// new page only means adding an entry there, not touching this file.
function App() {
  const publicRoutes = appRoutes.filter((route) => !route.protected);
  const protectedRoutes = appRoutes.filter((route) => route.protected);

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {publicRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route element={<ProtectedRoute />}>
            {protectedRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Route>
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Suspense>

      <ToastContainer />
      <SessionTimeoutWatcher />
      <PushNotificationListener />
    </>
  );
}

export default App;
